export const HiringManagers = ({ primaryFontColor = "#ffd800" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24.283"
      height="24.283"
      viewBox="0 0 24.283 24.283"
    >
      <path
        id="user"
        d="M27.141,15A12.141,12.141,0,1,0,39.283,27.141,12.141,12.141,0,0,0,27.141,15Zm0,3.755A3.848,3.848,0,1,1,23.294,22.6,3.848,3.848,0,0,1,27.141,18.755ZM32.28,34.811a9.821,9.821,0,0,1-10.277,0,3.061,3.061,0,0,1-.654-4.673,7.861,7.861,0,0,1,11.586,0A3.061,3.061,0,0,1,32.28,34.811Z"
        transform="translate(-15 -15)"
        fill={primaryFontColor}
      />
    </svg>
  );
};
